import { useLanguage } from "@/context/LanguageContext";
import { C } from "@/data/content";
import Reveal, { SectionHeader } from "@/components/Reveal";
import RouteMap from "@/components/RouteMap";

export default function Markets() {
    const { L } = useLanguage();

    return (
        <section
            id="markets"
            className="border-y border-gold-line/40 bg-ink-2/40 py-24 sm:py-32"
        >
            <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-12">
                <div className="order-2 lg:order-1 lg:col-span-5">
                    <SectionHeader
                        eyebrow={L(C.markets.eyebrow)}
                        title={L(C.markets.title)}
                    />
                    <Reveal delay={0.12}>
                        <p className="mt-8 leading-relaxed text-txt-2">
                            {L(C.markets.text)}
                        </p>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <div className="mt-8 flex flex-wrap items-center gap-3">
                            {C.markets.chips.map((ch, i) => (
                                <span
                                    key={i}
                                    data-testid={`market-chip-${i}`}
                                    className={`rounded-full px-5 py-2 text-sm ${
                                        i === 0
                                            ? "border border-gold-line-strong bg-brass/10 font-semibold text-brass-bright"
                                            : "border border-gold-line-strong text-txt-1"
                                    }`}
                                >
                                    {L(ch)}
                                </span>
                            ))}
                        </div>
                    </Reveal>
                </div>

                <div className="order-1 lg:order-2 lg:col-span-7">
                    <Reveal delay={0.1}>
                        <RouteMap
                            labels={C.markets.nodes}
                            className="mx-auto w-full max-w-2xl"
                        />
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
